<template>
  <div id="terms-of-service" class="container">
    <!-- HEADER -->
    <section class="pt-lg-5 py-4">
      <div class="row">
        <div class="col-12">
          <section-header title="Terms of Service" subtitle="Art Grab" />
        </div>
      </div>
    </section>

    <div class="row content-section">
      <div class="col-md-12">
        <p>
          Please read these terms of service (“Agreement”) carefully before
          using the services offered by Art Grab, LLC (the “Company”). This
          agreement applies to all visitors, users, buyers and others who access
          the services (as defined below).
        </p>
        <p>
          By visiting the websites or using the services in any manner, you
          agree that you have read and agree to be bound by and a party to the
          terms and conditions of this agreement to the exclusion of all other
          terms. If the terms of this agreement are considered an offer,
          acceptance is expressly limited to such terms. If you do not
          unconditionally agree to all the terms and conditions of this
          agreement, you have no right to use the website or services (including
          any content). Access to the website and use of company’s services is
          expressly conditioned upon your assent to all the terms and conditions
          of this agreement, to the exclusion of all other terms.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Services</h2>
      </div>
      <div class="col-md-12">
        <p>
          The artgrab.co website and domain name and any other linked pages,
          features, content, or application services (including without
          limitation any mobile application services) offered from time to time
          by the Company in connection therewith (collectively, the “Website”)
          are owned and operated by the Company. Subject to the terms and
          conditions of this Agreement, the Company may offer to provide certain
          services, as described more fully on the Website, and that have been
          selected by you (together with the Website, the “Services”), solely
          for your own use, and not for the use or benefit of any third party.
          The term “Services” includes, without limitation, use of the Website,
          any service the Company performs for you and the Content (as defined
          below) offered by the Company on the Website. The Company may at its
          sole discretion and without any liability change, suspend or
          discontinue the Services at any time, including the availability of
          any feature, database, or Content. The Company may also impose limits
          on certain features and services or restrict your access to parts or
          all of the Services without notice or liability.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Agreement</h2>
      </div>
      <div class="col-md-12">
        <p>
          The Company reserves the right, in its sole discretion, to modify this
          Agreement at any time by posting a notice on the Website, or by
          sending you a notice. You shall be responsible for reviewing and
          becoming familiar with any such modifications. Your use of the
          Services following such notification constitutes your acceptance of
          the terms and conditions of this Agreement as modified.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Eligibility</h2>
      </div>
      <div class="col-md-12">
        <p>
          The Company does not knowingly collect or solicit personal information
          from anyone under the age of 18 or knowingly allow such persons to
          register for the Services. If you are under 18, please do not attempt
          to register for the Services or send any information about yourself to
          us, including your name, address, telephone number, or email address.
          No one under age 18 may provide any personal information to the
          Company or on the Services. In the event that we learn that we have
          collected personal information from a child under age 18 without
          verification of parental consent, we will delete that information as
          quickly as possible. If you believe that we might have any information
          from or about a child under 18, please contact us at
          contact@artgrab.co.
        </p>
        <p>
          You represent and warrant to the Company that: (i) you can form a
          binding contract with artgrab.co and if you are an individual (i.e.,
          not a corporation) that you are of legal age to form a binding
          contract or have your parent’s permission to do so, and are at least
          18 years or age or older; (ii) all registration information you submit
          is accurate and truthful; and (iii) you will maintain the accuracy of
          such information. You also certify that you are legally permitted to
          use and access the Services and take full responsibility for the
          selection and use of and access to the Services.
        </p>
        <p>
          This Agreement is void where prohibited by law, and the right to
          access the Services is revoked in such jurisdictions.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Content</h2>
      </div>
      <div class="col-md-12">
        <p>Exclusive License is governed by the following points:</p>
        <ul>
          <li>All sales are final.</li>
          <li>
            The Artist confirms through the
            <router-link to="/artistagreement">Artist Agreement</router-link
            >&nbsp;the image has not been licensed** (exclusively or royalty
            free) to any other parties.
          </li>
          <li>
            The Artist confirms the image does not infringe or violate the
            rights of any person or entity, and both the Customer (Licensee) and
            Artist are to indemnify and hold Art Grab, LLC, harmless from any
            loss, damages, or expenses arising from or related to any claims to
            the contrary. Art Grab, LLC is an intermediary that provisions an
            online marketplace for buyers and sellers of graphic artwork.
          </li>
          <li>
            Customer (Licensee) has the unrestricted right to use and exploit
            the image for any purpose, in any media, throughout the world.
            However, Artist does not condone use of the image in any hate
            speech, bullying, child pornography, or violence.
          </li>
          <li>
            Exclusive rights belong to the Customer (Licensee) in perpetuity and
            the image will no longer be available on Artgrab.co or directly
            through the Artist.
          </li>
          <li>
            Customer (Licensee) is free to edit, alter, add type face/font
            and/or animate image without limitation or restriction.
          </li>
          <li>License is not transferrable or sublicensable.</li>
        </ul>
        <p>
          You may download an image/s with purchase of credits (and other items
          displayed on the Services for download) for personal or commercial
          use, provided that you maintain all copyright and other notices
          contained in such Content.
        </p>
        <p>
          It is standard practice for participating artists to have posted
          images that are available on Art Grab on the internet and/or social
          media prior to posting them on Art Grab, or while posted on Art Grab.
          The Artist Agreement requires artists to acknowledge available images
          have not been previously licensed. The license and Artist Agreement
          state that once an image is licensed it will no longer be available
          through the artist, on the platform, or in any other manner. This is
          part of the value that is exchanged in the Art Grab exclusive license.
          From time-to-time, Art Grab also shares available images in its
          marketing and/or social media - pre-licensed status. This practice
          facilitates the artist's and platform's ability to market and offer
          the product. As a result, screenshots may exist on the internet and
          perpetuate beyond the time that any one image is claimed (licensed).
          Generally speaking, screenshots that are circulating should not be
          considered a violation. The artist and Art Grab should certainly
          discontinue marketing and/or reposting a licensed image, unless
          otherwise agreed upon with the licensee. This is not to say either
          party (Art Grab and/or artist) should be expected to take down
          previous posts, but rather, they should not be reposting, relicensing
          or marketing any licensed images.
        </p>

        <p>
          Upon claiming and downloading an image, delivered in zip pack format,
          the licensee (final customer) is provided with an exclusive license,
          an exhibit graphically referencing the licensed image, a time stamped
          copy of the “Artist Agreement” and the high resolution version of the
          image uploaded by the creator.
        </p>
        <p>
          Examples and guides to follow as a contributing artist, or customer
          who purchases an image or images on Art Grab:
        </p>
        <ol>
          <li>
            If an image were to be exclusively licensed on Art Grab and then the
            creator of the artwork (artist) went and did a deal with a magazine
            and the magazine published the image this would be a violation by
            the creator of the artwork (artist). The licensee could have a case
            against the creator of the artwork (artist).
          </li>
          <li>
            A licensed image, or image that ultimately becomes licensed, is
            screenshot off the internet and then used as unauthorized cover art
            on a streaming platform. The creator of the artwork (artist) and/or
            licensee could pursue the violator through channels set forth by the
            respective streaming platform.
          </li>
          <li>
            A content hub shares a licensed image and tags the creator of the
            artwork (artist). Per the Art Grab TOS this would not be a
            violation.
          </li>
          <li>
            An image has been licensed on Art Grab and the creator of the
            artwork (artist) continues to sell the image as a print or other
            product. This would be a violation. The licensee could have a case
            against the creator of the artwork (artist).
          </li>
          <li>
            An image has not yet been licensed on Art Grab, but is available on
            Art Grab, and the creator of the artwork (artist) has the image
            available on another site as a print or other product. Once the
            image becomes licensed through Art Grab the creator of the artwork
            (artist) should have it off the other site immediately.
          </li>
          <li>
            Artists and Art Grab should discontinue marketing and/or reposting
            any licensed images, unless otherwise agreed upon with the licensee.
            This is not to say that the artist and Art Grab should be expected
            to take down previous posts, but rather, artists and Art Grab should
            not be reposting, relicensing or marketing any licensed images.
          </li>
          <li>
            An image that has been previously licensed should never be uploaded
            to Art Grab.
          </li>
        </ol>
        <h3>The Spirit of the Art Grab License</h3>
        <p>
          Through the Art Grab Artist Agreement*, the licensee should have peace
          of mind that the artwork they have selected on Art Grab to represent
          their creative project is safe for them to use. With reference to the
          Art Grab Term License and Forever License, the licensee has full
          commercial rights. The Term and Forever licensee shall never transfer
          their license without express written consent from Art Grab or offer
          the artwork for sublicensing. A Forever Licensee shall have no
          recourse against a former Term Licensee for a takedown, given the Term
          Licensee can provide an expired Art Grab Term License.
        </p>
        <p>
          *Artist Agreement -
          <router-link to="/artistagreement"
            >View the Artist Agreement</router-link
          >
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Intellectual Property Rights</h2>
      </div>
      <div class="col-md-12">
        <p>
          You warrant, represent and agree that you will not contribute any
          Content or otherwise use the Services in a manner that (i) infringes
          or violates the intellectual property rights or proprietary rights,
          rights of publicity or privacy, or other rights of any third party;
          (ii) violates any law, statute, ordinance or regulation; (iii) is
          harmful, fraudulent, deceptive, threatening, abusive, harassing,
          tortious, defamatory, vulgar, obscene, libelous, or otherwise
          objectionable; (iv) impersonates any person or entity, including
          without limitation any employee or representative of Company; or (v)
          contains a virus, trojan horse, worm, time bomb, or other harmful
          computer code, file, or program. The Company reserves the right to
          remove any Content from the Services at any time, for any reason
          (including, but not limited to, upon receipt of claims or allegations
          from third parties or authorities relating to such Content or if the
          Company is concerned that you may have breached the immediately
          preceding sentence, or for no reason at all. You, not the Company,
          remain solely responsible for all Content that you upload, post,
          email, transmit, or otherwise disseminate using, or in connection
          with, the Services, and you warrant that you possess all rights
          necessary to provide such content to the Company and to grant the
          Company the rights to use such information in connection with the
          Services and as otherwise provided herein.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Warranties and Representations</h2>
      </div>
      <div class="col-md-12">
        <p>
          You warrant, represent and agree that you will not contribute any
          Content or otherwise use the Services in a manner that (i) infringes
          or violates the intellectual property rights or proprietary rights,
          rights of publicity or privacy, or other rights of any third party;
          (ii) violates any law, statute, ordinance or regulation; (iii) is
          harmful, fraudulent, deceptive, threatening, abusive, harassing,
          tortious, defamatory, vulgar, obscene, libelous, or otherwise
          objectionable; (iv) impersonates any person or entity, including
          without limitation any employee or representative of Company; or (v)
          contains a virus, trojan horse, worm, time bomb, or other harmful
          computer code, file, or program. The Company reserves the right to
          remove any Content from the Services at any time, for any reason
          (including, but not limited to, upon receipt of claims or allegations
          from third parties or authorities relating to such Content or if the
          Company is concerned that you may have breached the immediately
          preceding sentence, or for no reason at all. You, not the Company,
          remain solely responsible for all Content that you upload, post,
          email, transmit, or otherwise disseminate using, or in connection
          with, the Services, and you warrant that you possess all rights
          necessary to provide such content to the Company and to grant the
          Company the rights to use such information in connection with the
          Services and as otherwise provided herein.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Responsibility for activity</h2>
      </div>
      <div class="col-md-12">
        <p>
          You are responsible for all of your activity in connection with the
          Services. Any fraudulent, abusive, or otherwise illegal activity may
          be grounds for termination of your right to access or use the
          Services. You may not post or transmit, or cause to be posted or
          transmitted, any communication or solicitation designed or intended to
          obtain password, account, or private information from any other user
          of the Services. Use of the Services to violate the security of any
          computer network, crack passwords or security encryption codes,
          transfer or store illegal material (including material that may be
          considered threatening or obscene), or engage in any kind of illegal
          activity is expressly prohibited. You will not run Maillist, Listserv,
          any form of auto-responder, or “spam” on the Services, or any
          processes that run or are activated while you are not logged on to the
          Services, or that otherwise interfere with the proper working of or
          place an unreasonable load on the Services’ infrastructure. Further,
          the use of manual or automated software, devices, or other processes
          to “crawl,” “scrape,” or “spider” any portion of the Services is
          strictly prohibited. You will not decompile, reverse engineer, or
          otherwise attempt to obtain the source code of the Services. You will
          be responsible for withholding, filing, and reporting all taxes,
          duties and other governmental assessments associated with your
          activity in connection with the Services.
        </p>
        <p>
          You understand and agree that the Company shall have the sole right to
          decide whether you are in violation of any of the restrictions set
          forth in this Section, and shall have sole discretion regarding the
          course of action to take in connection therewith.
        </p>
        <p>
          Art Grab, LLC reserves the right to withhold commissions connected to
          any fraudulent charges and/or during the investigation of any
          potentially fraudulent activity.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Warranty disclaimer</h2>
      </div>
      <div class="col-md-12">
        <p>
          The Company has no special relationship with or fiduciary duty to you.
          You acknowledge that the Company has no control over, and no duty to
          take any action regarding: which users gain access to the Services;
          what Content you access via the Services; what effects the Content may
          have on you; how you may interpret or use the Content; or what actions
          you may take as a result of having been exposed to the Content. You
          release the Company from all liability for you having acquired or not
          acquired Content through the Services.
        </p>
        <p>
          The Services may contain, or direct you to websites containing,
          information that some people may find offensive or inappropriate. The
          Company makes no representations concerning any content contained in
          or accessed through the Services, and Company will not be responsible
          or liable for the accuracy, copyright compliance, legality or decency
          of material contained in or accessed through the Services. Company
          makes no representations or warranties regarding the accuracy of
          descriptions anywhere on the Services, or regarding suggestions or
          recommendations of services or products offered or purchased through
          the Services. Products and services purchased (whether or not
          following such recommendations and suggestions) are provided “AS IS”
          without any warranty of any kind from the Company or others unless,
          with respect to others (only), otherwise made expressly and
          unambiguously in writing by a designated third party for a specific
          product or service.
        </p>
        <p>
          THE SERVICES, CONTENT, WEBSITE, PRODUCTS AND SERVICES OBTAINED THROUGH
          THE WEBSITE, AND ANY SOFTWARE ARE PROVIDED ON AN ”AS IS” BASIS,
          WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING,
          WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR
          A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR THAT USE OF THE SERVICES
          WILL BE UNINTERRUPTED OR ERROR-FREE. SOME STATES DO NOT ALLOW
          LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS, SO THE ABOVE
          LIMITATIONS MAY NOT APPLY TO YOU.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Subscription plans and purchase of art credits</h2>
      </div>
      <div class="col-md-12">
        <p>
          The intended use of artgrab.co is for the subscriber to pay for access
          to the full collection of art on artgrab.co for immediate use as
          covered by the license of the resources in question. Artgrab.co can at
          any time introduce and enforce mechanisms that prevent large amounts
          of resources being downloaded in a manner deemed unintended or
          malicious.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Billing Policies</h2>
      </div>
      <div class="col-md-12">
        <p>
          Certain aspects of the Services may be provided for a fee or other
          charge. If you elect to use paid aspects of the Services, you agree to
          the pricing and payment terms as we may update them from time to time.
          You shall pay all applicable fees, as described on the Website in
          connection with such Services selected by you. The Company reserves
          the right to change its price list and to institute new charges at any
          time, upon notice to you, which may be sent by email or posted on the
          Website. Your use of the Services following such notification
          constitutes your acceptance of any new or increased charges.
        </p>
        <p>
          All information that you provide in connection with a purchase or
          transaction or other monetary transaction interaction with the Service
          must be accurate, complete, and current. You agree to pay all charges
          incurred by users of your credit card, debit card, or other payment
          method used in connection with a purchase or transaction or other
          monetary transaction interaction with the Service at the prices in
          effect when such charges are incurred. You will pay any applicable
          taxes, if any, relating to any such purchases, transactions or other
          monetary transaction interactions. You may cancel your account with
          the Company at any time; however, there are no refunds for
          cancellation. In the event that the Company suspends or terminates
          your account or this Agreement for any reason, you understand and
          agree that you shall receive no refund or exchange for any Content or
          Services, any credits you have saved, any license or subscription fees
          for any portion of the Services, any content or data associated with
          your account, or for anything else.
        </p>
        <p>$1 License Details Authentication Fee is Non-Refundable</p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Indemnity</h2>
      </div>
      <div class="col-md-12">
        <p>
          You will indemnify and hold the Company, its parents, subsidiaries,
          affiliates, officers, and employees harmless (including, without
          limitation, from all damages, liabilities, settlements, costs and
          attorneys’ fees) from any claim or demand made by any third party due
          to or arising out of your access to the Services, use of the Services,
          your violation of this Agreement, or the infringement by you or any
          third party using your account of any intellectual property or other
          right of any person or entity.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Limitation of liability</h2>
      </div>
      <div class="col-md-12">
        <p>
          TO THE FULLEST EXTENT ALLOWED BY APPLICABLE LAW, IN NO EVENT SHALL
          COMPANY OR ITS SUPPLIERS, OR THEIR RESPECTIVE OFFICERS, DIRECTORS,
          EMPLOYEES, OR AGENTS BE LIABLE WITH RESPECT TO THE WEBSITE OR THE
          SERVICES OR THE SUBJECT MATTER OF THIS AGREEMENT UNDER ANY CONTRACT,
          NEGLIGENCE, TORT, STRICT LIABILITY OR OTHER LEGAL OR EQUITABLE THEORY
          (I) FOR ANY AMOUNT IN THE AGGREGATE IN EXCESS OF THE GREATER OF $100
          OR THE FEE PAID BY YOU TO THE COMPANY HEREUNDER FOR THE SERVICE
          CAUSING THE APPLICABLE CLAIM; (II) FOR ANY INDIRECT, INCIDENTAL,
          PUNITIVE, OR CONSEQUENTIAL DAMAGES OF ANY KIND WHATSOEVER; (III) FOR
          DATA LOSS OR COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; OR
          (IV) FOR ANY MATTER BEYOND COMPANY’S REASONABLE CONTROL. SOME STATES
          DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR
          CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATIONS AND EXCLUSIONS MAY NOT
          APPLY TO YOU.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Interaction with third parties</h2>
      </div>
      <div class="col-md-12">
        <p>
          The Services may contain links to third party websites or services
          (“Third Party Services”) that are not owned or controlled by Company,
          or the Services may be accessible by logging in through a Third Party
          Service. When you access Third Party Services, you do so at your own
          risk. You hereby represent and warrant that you have read and agree to
          be bound by all applicable policies of any Third Party Services
          relating to your use of the Services and that you will act in
          accordance with those policies, in addition to your obligations under
          this Agreement. Company has no control over, and assumes no
          responsibility for, the content, accuracy, privacy policies, or
          practices of or opinions expressed in any Third Party Services. In
          addition, Company will not and cannot monitor, verify, censor or edit
          the content of any Third Party Service. By using the Services, you
          expressly relieve and hold harmless the Company from any and all
          liability arising from your use of any Third Party Service.
        </p>
        <p>
          Your interactions with organizations and/or individuals found on or
          through the Services, including payment and delivery of goods or
          services, and any other terms, conditions, warranties or
          representations associated with such dealings, are solely between you
          and such organizations and/or individuals. You should make whatever
          investigation you feel necessary or appropriate before proceeding with
          any online or offline transaction with any of these third parties. You
          agree that the Company shall not be responsible or liable for any loss
          or damage of any sort incurred as the result of any such dealings.
        </p>
        <p>
          If there is a dispute between participants on the Website, or between
          users and any third party, you understand and agree that the Company
          is under no obligation to become involved. In the event that you have
          a dispute with one or more other users or third parties, you hereby
          release the Company, its officers, employees, agents, and successors
          in rights from claims, demands, and damages (actual and consequential)
          of every kind or nature, known or unknown, suspected or unsuspected,
          disclosed or undisclosed, arising out of or in any way related to such
          disputes.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Termination</h2>
      </div>
      <div class="col-md-12">
        <p>
          This Agreement shall remain in full force and effect while you use the
          Services. You may terminate your use of the Services at any time. The
          Company may without course and by reimbursement of any prepaid fees
          covering future periods terminate or suspend your access to the
          Services or your membership at any time, for any reason, and without
          warning, which may result in the forfeiture and destruction of all
          information associated with your membership. The Company may also
          terminate or suspend any and all Services and access to the Website
          immediately, without prior notice or liability, if you breach any of
          the terms or conditions of this Agreement. Upon termination of your
          account, your right to use the Services, access the Website, and any
          Content will immediately cease. All provisions of this Agreement
          which, by their nature, should survive termination, shall survive
          termination, including, without limitation, ownership provisions,
          warranty disclaimers, and limitations of liability.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Non-waiver</h2>
      </div>
      <div class="col-md-12">
        <p>
          The failure of either party to exercise, in any respect, any right
          provided for herein shall not be deemed a waiver of any further rights
          hereunder. The Company shall not be liable for any failure to perform
          its obligations hereunder where such failure results from any cause
          beyond the Company’s reasonable control, including, without
          limitation, mechanical, electronic or communications failure or
          degradation (including “line-noise” interference). If any provision of
          this Agreement is found to be unenforceable or invalid, that provision
          shall be limited or eliminated to the minimum extent necessary so that
          this Agreement shall otherwise remain in full force and effect and
          enforceable.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Assignment</h2>
      </div>
      <div class="col-md-12">
        <p>
          This Agreement is not assignable, transferable or sublicensable by you
          except with the Company’s prior written consent. The Company may
          transfer, assign or delegate this Agreement and its rights and
          obligations without consent. Both parties agree that this Agreement is
          the complete and exclusive statement of the mutual understanding of
          the parties and supersedes and cancels all previous written and oral
          agreements, communications and other understandings relating to the
          subject matter of this Agreement, and that all modifications must be
          in a writing signed by both parties, except as otherwise provided
          herein. No agency, partnership, joint venture, or employment is
          created as a result of this Agreement and you do not have any
          authority of any kind to bind Company in any respect whatsoever.
          Headings for each section have been included above for your
          convenience, but such headings do not have any legal meaning, and may
          not accurately reflect the content of the provisions they precede.
          Except as expressly set forth in Section 15 below, you and Company
          agree there are no third party beneficiaries intended under this
          Agreement.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Arbitration; Governing law</h2>
      </div>
      <div class="col-md-12">
        <p>
          The Website is controlled by the Company from offices within Utah,
          USA., but can be accessed from countries around the world. Any dispute
          arising from or relating to the subject matter of this Agreement shall
          be finally and exclusively settled by the Salt Lake County Court as
          first instance.
        </p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>DMCA Takedown</h2>
        <p>
          Art Grab, LLC. is a third party intermediary. We facilitate
          transactions between buyers and sellers of graphic artworks. If an
          image on this site violates your copyrights please send us an email
          to:
        </p>
        <p>DMCA.Takedown@Artgrab.co</p>
      </div>
    </div>

    <div class="row content-section">
      <div class="col-md-12">
        <h2>Contact information</h2>
        <p>
          If you have any questions, complaints, or claims with respect to the
          Services, you may contact us at:
        </p>
        <p>Contact@Artgrab.co</p>
      </div>
    </div>
  </div>
</template>

<script>
import { SectionHeader } from "../../components";
const artgrabURL = process.env.VUE_APP_ARTGRAB_URL;

export default {
  name: "terms-page",
  metaInfo() {
    return {
      title: "Terms of Service - Art Grab",
      meta: [
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: `summary_large_image`,
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: `Terms of Service - Art Grab`,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: `Please read these terms of service carefully before using the services offered by Art Grab, LLC. This agreement applies to all visitors, users, buyers and others who access the services.`,
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content: "https://i.imgur.com/gp9AfzO.jpeg",
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `https://artgrab.co/terms`,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: `Terms of Service - Art Grab`,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: `Please read these terms of service carefully before using the services offered by Art Grab, LLC. This agreement applies to all visitors, users, buyers and others who access the services.`,
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: "https://i.imgur.com/gp9AfzO.jpeg",
        },
        {
          vmid: "description",
          property: "description",
          content: `Please read these terms of service carefully before using the services offered by Art Grab, LLC. This agreement applies to all visitors, users, buyers and others who access the services.`,
        },
      ],
      link: [{ rel: "canonical", href: `${artgrabURL}/terms` }],
    };
  },
  components: {
    SectionHeader,
  },
  mounted() {
    this.$store.commit("setLayout", "page-layout");
  },
};
</script>

<style scoped lang="scss">
#terms-of-service {
  padding-top: 100px;
  padding-bottom: 80px;

  h2 {
    margin-bottom: 0.5rem;
  }

  .content-section {
    margin-bottom: 2rem;

    ul {
      list-style: disc;

      li:not(last-child) {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
